import React from 'react';
import Link from 'next/link';
import Styles from './styles.js';
const TitleSectionThree = ({ title, btnTxt, href, bg }) => {
  return (
    <>
      {bg ? (
        <div className="" style={{ backgroundColor: '#161616' }}>
          <div className=" text-center  pt-4 pb-4 container mx-auto ">
            <div className="flex flex-wrap items-center pt-4 pb-3 justify-center  ">
              <div className="flex justify-center items-center px-3 py-3">
                <div>
                  <h3
                    className="uppercase responsive-fs fw-400  text-center text-white"
                    style={{ fontFamily: 'Fjalla One', color: '#ffff' , fontSize:'48px',lineHeight:'54px'}}>
                    {title}
                  </h3>
                </div>
              </div>
              <div className="flex justify-center items-center px-3 py-3">
                <div className="text-center">
                  <Link href={href}>
                    <button
                      type="button"
                      className="btn btn-res text-lg rounded-0 "
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',

                        padding: '14px 28px',
                      }}>
                      {btnTxt}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        
        <div className="" >
        <div className=" text-center  py-6 container mx-auto ">
          <div className="flex flex-wrap items-center pt-4 pb-3 justify-center  ">
            <div className="flex justify-center items-center px-3 py-3">
              <div>
                <h3
                  className="uppercase responsive-fs fw-400  text-center text-black"
                  style={{ fontFamily: 'Fjalla One', fontSize:'48px', lineHeight:'54px' }}>
                  {title}
                </h3>
              </div>
            </div>
            <div className="flex justify-center items-center px-3 py-3">
              <div className="text-center">
                <Link href={href}>
                  <button
                    type="button"
                    className="btn btn-res fs-16-18 rounded-0 "
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',

                      padding: '14px 28px',
                    }}>
                    {btnTxt}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
      <Styles/>
    </>
  );
};

export default TitleSectionThree;
